export const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

// export const baseUrl = "https://api.easytipping.com/api/v1";
